import React from 'react'
import { Collections } from 'features/homepage/Collections'
import { getCurrentUser } from 'lib/utils'
import { OrganizationLayout } from '../OrganizationLayout'

export const OrganizationCollections = () => {
  return (
    <OrganizationLayout>
      <Collections user={getCurrentUser()} />
    </OrganizationLayout>
  )
}
